import { products } from '@/mocks/products';
import { layers } from '@/mocks/layers';

interface MobileMenuProps {
  open: boolean;
  keyword: string;
  setKeyword: (v: string) => void;
  onClose: () => void;
}

const layerColors: Record<string, string> = {
  strategic: '#FF6B35',
  foundation: '#00D4FF',
  marketing: '#A855F7',
  fishery: '#10B981',
};

export default function MobileMenu({ open, keyword, setKeyword, onClose }: MobileMenuProps) {
  if (!open) return null;

  const filtered = keyword.trim()
    ? products.filter((p) =>
        [p.name, p.slogan, p.layer, ...(p.tags || [])]
          .join(' ')
          .toLowerCase()
          .includes(keyword.toLowerCase())
      )
    : [];

  return (
    <div className="fixed inset-0 z-[90] bg-[#030712]/95 backdrop-blur-xl pt-20 px-6 pb-8 md:hidden overflow-y-auto">
      {/* 搜索 */}
      <div className="relative mb-8">
        <input
          type="text"
          placeholder="搜索产品..."
          value={keyword}
          onChange={(e) => setKeyword(e.target.value)}
          className="w-full px-5 py-3 bg-white/5 border border-white/10 rounded-xl text-sm text-white placeholder-white/40 focus:outline-none focus:border-[#00D4FF]/50"
        />
        <i className="ri-search-line absolute right-4 top-1/2 -translate-y-1/2 text-white/40"></i>
      </div>

      {/* 层级导航 */}
      <div className="space-y-2 mb-8">
        <div className="text-xs tracking-[0.2em] text-white/40 mb-3">层级导航</div>
        {layers.map((layer) => (
          <a
            key={layer.id}
            href={`#${layer.id}`}
            onClick={onClose}
            className="flex items-center gap-3 px-4 py-3 rounded-xl bg-white/5 border border-white/10 text-white/70 hover:text-white transition-colors"
            style={{ borderColor: `${layerColors[layer.id]}20` }}
          >
            <span className="w-2 h-2 rounded-full" style={{ backgroundColor: layerColors[layer.id] }}></span>
            <span className="font-medium">{layer.layer}</span>
            <span className="text-xs opacity-50 ml-auto">({layer.products.length})</span>
          </a>
        ))}
      </div>

      {/* 快捷链接 */}
      <div className="space-y-2 mb-8">
        <div className="text-xs tracking-[0.2em] text-white/40 mb-3">快捷链接</div>
        <a
          href="https://luyuaqua.com"
          target="_blank"
          rel="noopener noreferrer"
          onClick={onClose}
          className="flex items-center gap-3 px-4 py-3 rounded-xl bg-white/5 border border-white/10 text-white/70 hover:text-[#00D4FF] transition-colors"
        >
          <i className="ri-global-line"></i>
          <span>陆渔科技官网</span>
        </a>
        <a
          href="https://auaa.luyuaqua.com"
          target="_blank"
          rel="noopener noreferrer"
          onClick={onClose}
          className="flex items-center gap-3 px-4 py-3 rounded-xl bg-white/5 border border-white/10 text-white/70 hover:text-[#00D4FF] transition-colors"
        >
          <i className="ri-rocket-2-line"></i>
          <span>确定性农业引擎</span>
        </a>
      </div>

      {/* 搜索结果 */}
      {keyword.trim() && (
        <div className="space-y-2">
          <div className="text-xs tracking-[0.2em] text-white/40 mb-3">
            搜索结果 ({filtered.length})
          </div>
          {filtered.length === 0 ? (
            <div className="text-sm text-white/40 py-4 text-center">
              没有找到匹配产品
            </div>
          ) : (
            filtered.map((p) => (
              <div
                key={p.id}
                className="flex items-center gap-3 px-4 py-3 rounded-xl bg-white/5 border border-white/10"
              >
                <i className={`${p.icon} text-lg`} style={{ color: layerColors[p.category] }}></i>
                <div>
                  <div className="text-sm text-white">{p.name}</div>
                  <div className="text-xs text-white/50">{p.slogan}</div>
                </div>
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
}